/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Document type to export as e-SLOG XML
 */
export type EslogExportByDateRangeTypesItem = typeof EslogExportByDateRangeTypesItem[keyof typeof EslogExportByDateRangeTypesItem];


export const EslogExportByDateRangeTypesItem = {
  invoice: 'invoice',
  estimate: 'estimate',
  credit_note: 'credit_note',
} as const;
